import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonBanner } from './Banner.definition';
import { chameleonButton } from '../Button/Button.definition';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonBanner({ prefix }), chameleonButton({ prefix }), chameleonIconButton({ prefix }));
}
